export const FORSUBMIT = {
  REQUEST: 'Invoices/ForSubmit/Request',
  SUCCESS: 'Invoices/ForSubmit/Success',
  FAILURE: 'Invoices/ForSubmit/Failure'
};

export const CREATE_INVOICE = {
  REQUEST: 'Invoices/CreateInvoice/Request',
  SUCCESS: 'Invoices/CreateInvoice/Success',
  FAILURE: 'Invoices/CreateInvoice/Failure'
};

export const DELETE_INVOICE = {
  REQUEST: 'Invoices/DeleteInvoice/Request',
  SUCCESS: 'Invoices/DeleteInvoice/Success',
  FAILURE: 'Invoices/DeleteInvoice/Failure'
};

export const UPDATE_INVOICE = {
  REQUEST: 'Invoices/UpdateInvoice/Request',
  SUCCESS: 'Invoices/UpdateInvoice/Success',
  FAILURE: 'Invoices/UpdateInvoice/Failure'
};

export const GET_INVOICE = {
  REQUEST: 'Invoices/GetInvoice/Request',
  SUCCESS: 'Invoices/GetInvoice/Success',
  FAILURE: 'Invoices/GetInvoice/Failure'
};

export const CLEAR_INVOICE = {
  SUCCESS: 'Invoices/ClearInvoice/Success'
};

export const TOGGLE_AS_PAID = {
  REQUEST: 'Invoices/ToggleAsPaid/Request',
  SUCCESS: 'Invoices/ToggleAsPaid/Success',
  FAILURE: 'Invoices/ToggleAsPaid/Failure'
};
